export const MESSAGES = Object.freeze({
	SCHEME_ADDED: 'Scheme Added SuccessFully',
});
